<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Almoxarifado/Baixar Requisição </label>
    </div>
    <v-container fluid
      ><v-row align="center">
       <v-col cols="12" sm="2">
           <!--<v-btn
            color="info"
            to="/requisicao/criar"
            v-if="isAllowed(9)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>-->
        </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                  <v-avatar color="primary" size="25">
                    <span class="white--text text-h6">TD</span>
                  </v-avatar>
                  <div class="ma-1 text-h5">Todas</div>
              </template>
            </v-radio>
            <v-radio value="PA">
              <template v-slot:label>
                  <v-avatar color="red" size="25">
                    <span class="white--text text-h6">PA</span>
                  </v-avatar>
                  <div class="ma-1 text-h5">Pend. Almoxarifado</div>
              </template>
            </v-radio>
            <v-radio value="AP">
              <template v-slot:label>
                  <v-avatar color="yellow" size="25">
                    <span class="white--text text-h6">AP</span>
                  </v-avatar>
                  <div class="ma-1 text-h5">Atendida Parcial</div>
              </template>
            </v-radio>
            <v-radio value="AT">
              <template v-slot:label>
                  <v-avatar color="yellow" size="25">
                    <span class="white--text text-h6">AT</span>
                  </v-avatar>
                  <div class="ma-1 text-h5">Atendida Total</div>
              </template>
            </v-radio>
            <v-radio value="B">
              <template v-slot:label>
                  <v-avatar color="green" size="25">
                    <span class="white--text text-h6">B</span>
                  </v-avatar>
                  <div class="ma-1 text-h5">Baixada</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="1">
          <v-btn
            @click="baixarlista()"
            v-if="requisicoesBaixa.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :custom-filter="filter"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <!--<template v-slot:item.autorizado="{ item }">
          {{ item.autorizado ? "Sim" : "Não" }}
        </template>-->
        <template v-slot:item.prioridade="{ item }">
          {{ item.prioridade == "Normal" ? "Normal" : "Emergencial" }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'AA'" color="red" size="24">
            <span class="white--text text-h5">AA</span>
          </v-avatar>
          <v-avatar v-if="item.status == 'PA'" color="red" size="24">
            <span class="white--text text-h5">PA</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'AP'" color="yellow" size="24">
            <span class="white--text text-h5">AP</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'AT'" color="yellow" size="24">
            <span class="white--text text-h5">AT</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'B'" color="green" size="24">
            <span class="white--text text-h5">B</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'D'" color="green" size="24">
            <span class="white--text text-h5">D</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'I'" color="green" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.id ="{ item }">
          {{ item.nome == null ? item.id : item.nome }}
        </template>
        <!--<template v-slot:header="{ header }">
          <tr class="grey lighten-3">
            <th>
              <v-icon>filter_list</v-icon>
            </th>
            <th v-for="header in headers" :key="header.text">
              <div v-if="filters.hasOwnProperty(header.value)">
                <v-autocomplete
                  flat
                  hide-details
                  multiple
                  attach
                  chips
                  dense
                  clearable
                  :items="columnValueList(header.value)"
                  v-model="filters[header.value]"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 7">
                      <span>
                        {{ getStyle(item)  }}
                      </span>
                    </v-chip>
                    <span v-if="index === 7" class="grey--text caption">
                      (+{{ filters[header.value].length - 7 }} others)
                    </span>
                  </template>
                </v-autocomplete>
              </div>
            </th>
          </tr>
        </template>-->
        <template v-slot:item.quantidade="{ item }">
          <v-text-field
            v-model="item.quantidade"
            hide-details
            single-line
            type="number"
            :readonly="apenasLeitura"
          >
          </v-text-field>
        </template>
        <template v-slot:item.observacao="{ item }">
          <v-text-field v-model="item.observacao" :readonly="apenasLeitura">
          </v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip v-if="isAllowed(9) && statusPermite(item)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                class="mr-2"
                @click="baixar(item)"
                v-bind="attrs"
                v-on="on"
              >
              mdi-check-bold
              </v-icon>
            </template>
            <span v-if="isAllowed(9) && statusPermite(item)">Baixar</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data="{ item }">
          <span>{{ new Date(item.data).toLocaleString() }}</span>
        </template>
        <template v-slot:item.requisitante="{ item }">
          {{ item.usuarioSofit == null || item.usuarioSofit == '' ? item.requisitante : item.usuarioSofit }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getUserRoles } from "@/services/loginService";
import { downloadListaBaixa, getPdfBaixa } from "../../../services/requisicaoService";
import { getUserPermission } from "@/services/loginService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import moment from "moment";

export default {
  name: "listaRequisicao",
  data() {
    return {
      selectedFilter: "0",
      loading: false,
      search: "",
      showAtivo: false,
      apenasLeitura: false,
      active_tab: 2,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      arrayEvents: null,
      headers: [
        {
          text: "Req.",
          align: "start",
          value: "nome",
        },
        { text: "Data Hora", value: "data" },
        { text: "Unidade Adm", value: "unidadeAdm" },
        { text: "Local de Entrega", value: "local" },
        { text: "Requisitante", value: "requisitante" },
        { text: "Prioridade", value: "prioridade" },
        { text: "Status", value: "status" },
        { text: "SC", value: "IdSolicitacao" },
        { text: "", value: "actions", sortable: false,
        width: "10%", },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      filters: {
        nome: [],
        data: [],
        unidadeAdm: [],
        local: [],
        idOrdemServico: [],
        requisitante: [],
        prioridade: [],
      },
    };
  },
  computed: {
    ...mapState("requisicao", ["requisicoesBaixa"]),
    
    filteredList() {
      if (this.selectedFilter == "0") {
        if (this.dataIni !== null && this.dataFim !== null) {
          return this.requisicoesBaixa.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              new Date(r.data.split("T")[0]) >=
                new Date(this.dataIni.split("T")[0]) &&
              new Date(r.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              })
            );
          }).sort( function ( a, b ) { return b.id - a.id; } );
        } else {
          return this.requisicoesBaixa.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              })
            );
          }).sort( function ( a, b ) { return b.id - a.id; } );
        }
      } else {
        if (this.dataIni !== null && this.dataFim !== null) {
          return this.requisicoesBaixa.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              new Date(r.data.split("T")[0]) >=
                new Date(this.dataIni.split("T")[0]) &&
              new Date(r.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              }) &&
              r.status == this.selectedFilter
            );
          }).sort( function ( a, b ) { return b.id - a.id; } );
        } else {
          return this.requisicoesBaixa.filter((r) => {
            return (
              ((r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) &&
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase())) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              }) &&
              r.status == this.selectedFilter
            );
          }).sort( function ( a, b ) { return b.id - a.id; } );
        }
      }
    },
    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("requisicao", [
      "atualizarRequisicoesBaixa",
      "atualizarRequisicao",
    ]),
    columnValueList(val) {
      if (val == "data") {
        return this.requisicoesBaixa.map((d) => new Date(d[val]).toLocaleString().replace(/(.*)\D\d+/, "$1"));
      } else {
        return this.requisicoesBaixa.map((d) => d[val]);
      }
    },
    baixar(requisicao) {
      this.atualizarRequisicao(requisicao);
        this.$router.push({
          path: "/baixaRequisicao/baixar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarRequisicoesBaixa();
      this.loading = false;
    },
    baixarlista() {
      //downloadLista();
      const blob = this.gerarExcel();
      const nome_arquivo = "requisicoes.xlsx";
      saveAs(blob, nome_arquivo);
    },
    show(item) {
      getPdfBaixa(item.id, abrirJanelaPdf());
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    statusPermite(requisicao) {
      return requisicao.status === "PA";
    },
    getStyle(value) {
      if(value == '1')
      {
        return "Normal";
      }
      else if(value == 2)
      {
        return "Emergencial";
      }
      else {
        return value;
      }
    },
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate =  moment(val, 'DD/MM/YYYY');
        if (newDate.isValid()) {
          this.dataIni = moment(val, 'DD/MM/YYYY').format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate =  moment(val, 'DD/MM/YYYY');
        if (newDate.isValid()) {
          this.dataFim = moment(val, 'DD/MM/YYYY').format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
    filter(value, search, item) {
      if (this.selectedFilter == "0") {
        if (this.dataIni !== null && this.dataFim !== null) {
          return this.requisicoesBaixa.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              new Date(r.data.split("T")[0]) >=
                new Date(this.dataIni.split("T")[0]) &&
              new Date(r.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              })
            );
          });
        } else {
          return this.requisicoesBaixa.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              })
            );
          });
        }
      } else {
        if (this.dataIni !== null && this.dataFim !== null) {
          return this.requisicoesBaixa.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              new Date(r.data.split("T")[0]) >=
                new Date(this.dataIni.split("T")[0]) &&
              new Date(r.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              }) &&
              r.status == this.selectedFilter
            );
          });
        } else {
          return this.requisicoesBaixa.filter((r) => {
            return (
              ((r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) &&
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase())) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              Object.keys(this.filters).every((f) => {
                if (f == 'data'){
                  return (this.filters[f].length < 1 || this.filters[f].includes(new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")));
                  }
                else return (
                  this.filters[f].length < 1 || this.filters[f].includes(r[f])
                );
              }) &&
              r.status == this.selectedFilter
            );
          });
        }
      }
    },
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Req." },
        { chave: "data", cabecalho: "Data Hora" },
        { chave: "unidadeAdm", cabecalho: "UnidadeAdm" },
        { chave: "local", cabecalho: "Local de Entrega" },
        { chave: "requisitante", cabecalho: "Requisitante" },
        { chave: "prioridade", cabecalho: "Prioridade" },
        { chave: "IdSolicitacao", cabecalho: "SC" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(colunas.map((c) => c.chave == 'data' ? new Date(item[c.chave]).toLocaleString().replace(/(.*)\D\d+/, "$1") : item[c.chave]));
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col, i) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  mounted() {
    this.readOnly = !getUserPermission(1);
  },
  watch: {
    // quando o usuário muda a página na tabela, gravar na URL
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },

    // quando a URL muda (voltar do browser, entrar na tela), aplicar na tabela
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next }; // garante reatividade
        }
      },
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>
